import React from "react";

const AbsoluteLigne = () => {
  return (
    <div className="portfolio-content">
      <div className="ligne"></div>

      <div className="boule1 boule">
        <i className="fab fa-react"></i>
        <div className="bloc1 bloc">
          <div className="text">
            <h3>Groupomania</h3>
            <p>
              Groupomania est un réseau social qui permet de partager des
              informations et des événements entre les membres du groupe.
            </p>
          </div>
        </div>
      </div>

      <div className="boule2 boule">
        <i className="fa-brands fa-node"></i>

        <div className="bloc2 bloc">
          <div className="text">
            <h3>Piquante</h3>
            <p>
              Piiquante se dédie à la création de sauces épicées dont les
              recettes sont gardées secrètes. Pour tirer parti de son succès et
              générer davantage de buzz.
            </p>
          </div>
        </div>
      </div>

      <div className="boule3 boule">
        <i className="fa-brands fa-js"></i>

        <div className="bloc3 bloc">
          <div className="text">
            <h3>Kanap</h3>
            <p>
              Kanap une marque de canapés qui vend ses produits depuis sa
              boutique exclusivement.
            </p>
          </div>
        </div>
      </div>

      <div className="boule4 boule">
        <i className="fa-solid fa-magnifying-glass"></i>

        <div className="bloc4 bloc">
          <div className="text">
            <h3>Panther</h3>
            <p>
              Groupomania est un réseau social qui permet de partager des
              informations et des événements entre les membres du groupe.
            </p>
          </div>
        </div>
      </div>

      <div className="boule5 boule">
        <i className="fa-brands fa-sass"></i>

        <div className="bloc5 bloc">
          <div className="text">
            <h3>Oh myfood</h3>
            <p>
              Oh-myfood un site proposant le menu de 4 grands restaurants
              parisiens le site permet la réservation en ligne et la composition
              de menus.
            </p>
          </div>
        </div>
      </div>

      <div className="boule6 boule">
        <i className="fab fa-html5"></i>
        <i className="fa-brands fa-css3"></i>

        <div className="bloc6 bloc">
          <div className="text">
            <h3>Bookie</h3>
            <p>
              Le site permet aux usagers de trouver des hébergements et des
              activités dans la ville de leur choix. Les hébergements peuvent
              également être filtrés par thématique, par exemple leur budget ou
              leur ambiance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbsoluteLigne;
